import {
    ExistingMappingRemoved,
    ExistingMappingSelected,
    ExtraOptionsClear,
    ExtraOptionsUpdate,
} from "event-definitions"
import { FIXED_VALUE_OPTION } from "./fixed-value-option"

ExistingMappingSelected.handle(({ mappings }) => {
    handleFixedMappings(mappings, updateExtraOptions)

    function updateExtraOptions(selectId, value) {
        ExtraOptionsUpdate(selectId).raise({ id: FIXED_VALUE_OPTION, value })
    }
})

ExistingMappingRemoved.handle(({ mappings }) => {
    handleFixedMappings(mappings, clearExtraOptions)

    function clearExtraOptions(selectId) {
        ExtraOptionsClear(selectId).raise()
    }
})

function handleFixedMappings(mappings, fn) {
    Object.entries(mappings)
        .filter(([key]) => key.endsWith("_fixed"))
        .forEach(([key, value]) => {
            const selectId = key.replace("_fixed", "")
            fn(selectId, value)
        })
}
